{
    "warning": "¡ADVERTENCIA!",
    "message": "No ingreses ni pegues código que no entiendas.\nSi usás esta consola, los atacantes podrían hacerse pasar por vos y robar tu información por medio de un ataque llamado Self-XSS."
}
